export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11325.b8683375.jpg";